import { AuthTypes, ProfileTypes } from '@services/data-types/user';
import { authTokenInitial, profileInitial } from '@services/initialvalue/auth';
import { create } from 'zustand';
import { persist } from 'zustand/middleware'

interface AuthState {
    auth: AuthTypes,
    profile: ProfileTypes,
    updateAuth: (auth: AuthTypes) => void
    updateProfile: (newProfile: ProfileTypes) => void,
    logout: () => void


}

export const useAuthStore = create<AuthState>()(
    persist(
        (set, get) => ({
            auth: authTokenInitial,
            profile: profileInitial,
            updateAuth: (newAuth: AuthTypes) => set(prev => ({ ...prev, auth: newAuth })),
            updateProfile: (newProfile: ProfileTypes) => set(prev => ({ ...prev, profile: newProfile })),
            logout: () => set({
                auth: authTokenInitial,
                profile: profileInitial,
            }),
        }),
        {
            name: 'auth',
            serialize: (state) => btoa(JSON.stringify(state)),
            deserialize: (str) => JSON.parse(atob(str)),
        }
    )
);